export var BrewingMethod;
(function (BrewingMethod) {
    BrewingMethod["ESPRESSO"] = "espresso";
    BrewingMethod["POUR_OVER"] = "pour_over";
    BrewingMethod["FRENCH_PRESS"] = "french_press";
    BrewingMethod["AEROPRESS"] = "aeropress";
    BrewingMethod["COLD_BREW"] = "cold_brew";
    BrewingMethod["DRIP"] = "drip";
    BrewingMethod["MOKA_POT"] = "moka_pot";
    BrewingMethod["CHEMEX"] = "chemex";
    BrewingMethod["V60"] = "v60";
    BrewingMethod["SIPHON"] = "siphon";
})(BrewingMethod || (BrewingMethod = {}));
export var RecipeDifficulty;
(function (RecipeDifficulty) {
    RecipeDifficulty["BEGINNER"] = "beginner";
    RecipeDifficulty["INTERMEDIATE"] = "intermediate";
    RecipeDifficulty["ADVANCED"] = "advanced";
    RecipeDifficulty["EXPERT"] = "expert";
})(RecipeDifficulty || (RecipeDifficulty = {}));
export var RecipeStatus;
(function (RecipeStatus) {
    RecipeStatus["DRAFT"] = "draft";
    RecipeStatus["PUBLISHED"] = "published";
    RecipeStatus["ARCHIVED"] = "archived";
    RecipeStatus["PENDING_REVIEW"] = "pending_review";
})(RecipeStatus || (RecipeStatus = {}));
export var GrindSize;
(function (GrindSize) {
    GrindSize["EXTRA_COARSE"] = "extra_coarse";
    GrindSize["COARSE"] = "coarse";
    GrindSize["MEDIUM_COARSE"] = "medium_coarse";
    GrindSize["MEDIUM"] = "medium";
    GrindSize["MEDIUM_FINE"] = "medium_fine";
    GrindSize["FINE"] = "fine";
    GrindSize["EXTRA_FINE"] = "extra_fine";
})(GrindSize || (GrindSize = {}));
